import React, { useState, useEffect } from "react"
import TextField from "@material-ui/core/TextField"
import Autocomplete from "@material-ui/lab/Autocomplete"
import CircularProgress from "@material-ui/core/CircularProgress"
import { Grid } from "@material-ui/core"
import Typography from "@material-ui/core/Typography"
import useStyles from "../../styles"
import api from "../../../../services/api"
import toastError from "../../../../errors/toastError"

// Componente para o Autocomplete de Contatos
const ContactAutocomplete = ({ initialContact, onContactSelect, selectedContact, loading, setLoading }) => {
  const classes = useStyles()
  const [options, setOptions] = useState([])
  const [searchParam, setSearchParam] = useState("")
  const [modalOpen, setModalOpen] = useState(true)

  useEffect(() => {
    if (initialContact?.id !== undefined) {
      setOptions([initialContact])
    }
  }, [initialContact])

  useEffect(() => {
    if (!modalOpen || searchParam.length < 3) {
      setOptions([])
      setLoading(false)
      return
    }

    setLoading(true)
    const delayDebounceFn = setTimeout(() => {
      const fetchContacts = async () => {
        try {
          const { data } = await api.get("/contacts/", {
            params: { searchParam },
          })
          setOptions(data.contacts)
          setLoading(false)
        } catch (err) {
          setLoading(false)
          toastError(err)
        }
      }
      fetchContacts()
    }, 500)

    return () => clearTimeout(delayDebounceFn)
  }, [searchParam, modalOpen, setLoading])

  const handleSelectOption = (e, newValue) => {
    if (newValue?.number) {
      onContactSelect(newValue)
    } else if (newValue?.name) {
      // Lógica para novo contato
    }
  }

  const createAddContactOption = (filterOptions, params) => {
    const inputValue = params.inputValue || ""
    const filtered = filterOptions.filter((option) => {
      if (!option) return false
      return true
    })

    if (inputValue !== "" && !loading && searchParam.length >= 3) {
      filtered.push({
        name: inputValue,
      })
    }

    return filtered
  }

  const renderOption = (option) => {
    if (option.number) {
      return (
        <Typography
          component="span"
          style={{
            fontSize: 14,
            marginLeft: "10px",
            display: "inline-flex",
            alignItems: "center",
            lineHeight: "2",
          }}
        >
          {option.empresa ? `${option.name} - ${option.empresa}` : `${option.name} (${option.number})`}
        </Typography>
      )
    } else {
      return `Incluir ${option.name}`
    }
  }

  const renderOptionLabel = (option) => {
    if (!option) return ""
    const name = option.name || ""
    const empresa = option.empresa || ""
    const number = option.number || ""

    if (number) {
      return empresa ? `${name} - ${empresa}` : `${name} (${number})`
    }
    return name
  }

  if (!initialContact) {
    return (
      <Grid xs={12} item>
        <Autocomplete
          className={classes.autocomplete}
          fullWidth
          options={options}
          loading={loading}
          clearOnBlur
          autoHighlight
          freeSolo
          clearOnEscape
          getOptionLabel={renderOptionLabel}
          renderOption={renderOption}
          filterOptions={createAddContactOption}
          onChange={handleSelectOption}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Digite para pesquisar o contato"
              variant="outlined"
              autoFocus
              onChange={(e) => {
                setSearchParam(e.target.value)
              }}
              onKeyPress={(e) => {
                if (loading || !selectedContact) return
                else if (e.key === "Enter") {
                  // Lógica para salvar ticket
                }
              }}
              InputLabelProps={{
                classes: {
                  root: classes.label,
                },
              }}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <React.Fragment>
                    {loading ? <CircularProgress color="inherit" size={20} /> : null}
                    {params.InputProps.endAdornment}
                  </React.Fragment>
                ),
              }}
            />
          )}
        />
      </Grid>
    )
  }
  return null
}
export default ContactAutocomplete
